<div class="val-facture-vente-page-conteneur val-flex-conteneur val-flex-colonne val-flex-center-vertical">
  
  <div class="val-facture-vente-page-entete val-flex-conteneur">
    <val-simple-libelle class="val-facture-vente-page-titre val-flex-1" 
      [libelle]="titre()"></val-simple-libelle>
    <div>
      <val-barre-menus [menuItems]="menuItems()"></val-barre-menus>
    </div>
  </div>

  <div class="val-facture-vente-page-contenu val-flex-1">
    @if (initialisationTermine$ | async) {
      <val-facture-vente-fiche-contenu #ficheContenu></val-facture-vente-fiche-contenu>
    }
  </div>

</div>
